/**
 * 工程のチェックリスト
 */
export class SubTask {
  taskId?: number;
  name: string = "";
  done: boolean = false;
  created: Date = new Date();
  dueDate: string = "";
  time: string = "";
  date: string = "";
  users: Array<object> = [];

  public constructor(params: SubTaskInput = {}) {
    if (params.taskId) this.taskId = params.taskId;
    if (params.name) this.name = params.name;
    if (params.done) this.done = params.done;
    if (params.created) this.created = params.created;
    if (params.time) this.time = params.time;
    if (params.date) this.date = params.date;
    if (params.users) this.users = params.users;
  }
}

export interface SubTaskInput {
  taskId?: number;
  name?: string;
  done?: boolean;
  created?: Date;
  dueDate?: string;
  time?: string;
  date?: string;
  users?: Array<object>;
}
